import { render, staticRenderFns } from "./Possession.vue?vue&type=template&id=224c5417&scoped=true&"
import script from "./Possession.vue?vue&type=script&lang=js&"
export * from "./Possession.vue?vue&type=script&lang=js&"
import style0 from "./Possession.vue?vue&type=style&index=0&id=224c5417&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c5417",
  null
  
)

export default component.exports